<template>
	<div>
		<div class="text-center w-100">
			<b-icon
				icon="three-dots"
				class="text-center"
				animation="cylon"
				font-scale="4"
				v-if="loadingStatus"
			></b-icon>
		</div>
		<b-row v-if="!loadingStatus">
			<b-col lg="12">
				<b-card no-body>
					<template v-slot:header>
						<h5 class="h3 mb-0">Search Result</h5>
					</template>
					<b-card-body class="p-3">
						<b-row style="display: none;">
							<b-col class="my-1 m-3">
								<b-form-group
									label="Show"
									label-for="per-page-select"
									label-cols-sm=""
									label-cols-md=""
									label-cols-lg=""
									label-align-sm="center"
									label-size="sm"
									class="mb-0 search-result-option"
								>
									<b-form-select
										id="per-page-select"
										v-model="perPage"
										:options="pageOptions"
										size="sm"
									></b-form-select>
								</b-form-group>
							</b-col>
						</b-row>
						<div class="primary-table">
							<b-table
								responsive
								striped
								hover
								no-local-sorting
								:items="items"
								:fields="fields"
								:filter="filter"
								:filter-included-fields="filterOn"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:sort-direction="sortDirection"
								class="text-center custom-table"
								show-empty
								small
								@filtered="onFiltered(items)"
								@sort-changed="sortChanged"
							>
								<template #cell(actions)="row">
									<i
										v-if="row.item.openStatus"
										class="fa fa-minus-circle"
										@click="row.toggleDetails"
										v-on:click="rowClick(row)"
									></i>
									<i
										v-if="!row.item.openStatus"
										class="fa fa-plus-circle"
										@click="row.toggleDetails"
										v-on:click="rowClick(row)"
										title="Click here to see the details for this SIM"
									></i>
								</template>

								<template #cell(Status)="row">
									<span class="text-success h1" v-if="row.value === 'Active'">● </span>
									<span class="text-danger h1" v-if="row.value !== 'Active'">● </span>
								</template>

								<template #cell(IMSI)="row">
									<b-link :to="'/sim_detail/:?imsi=' + row.item['IMSI']">
										{{ row.value }} <i class="ni ni-curved-next"></i>
									</b-link>
								</template>

								<template #cell(simType)="row">
									<b-badge
										:variant="changeSimTypeBadge(row.value)"
										class="m-1 cursor-pointer"
									>
										{{row.value}}
									</b-badge>
								</template>

								<template #row-details="row">
									<b-card
										class="card-table-custom mb-3"
										v-if="loadingStatusDetail && selectedIMSI === row.item['IMSI']"
									>
										<b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
									</b-card>

									<b-card
										class="card-table-custom"
										v-if="!loadingStatusDetail || selectedIMSI !== row.item['IMSI']"
									>
										<b-card-header class="pt-0">
											<div class="text-left">
												<b-badge
													variant="primary"
													class="m-1 cursor-pointer"
													v-b-modal.view-map
													v-on:click="viewMapDetail(row.item['IMSI'])"
												>
													<i class="fa fa-globe text-dark mr-2"></i>
													View Map
												</b-badge>
												<b-badge
													variant="info"
													class="m-1 cursor-pointer"
													v-b-modal.send-sms
													v-on:click="sendSMSDetail(row.item['MSISDN'])"
												>
													<i class="fa fa-paper-plane text-dark mr-2"></i>
													Send SMS
												</b-badge>
												<b-badge
													variant="success"
													class="m-1 cursor-pointer"
													v-b-modal.hlr-info
													v-on:click="hlrInfoDetail(row.item['IMSI'])"
												>
													<i class="fa fa-file text-dark mr-2"></i>
													HLR Info
												</b-badge>
												<b-badge
													variant="warning"
													class="m-1 cursor-pointer"
													v-b-modal.hss-info
													v-on:click="hssInfoDetail(row.item['IMSI'])"
												>
													<i class="fa fa-file text-dark mr-2"></i>
													HSS Info
												</b-badge>
											</div>
											<b-row class="mt-3">
												<b-col sm="2" class="white-space-custom">
													<b>Product</b>
													<p class="mt-3 text-sm">{{ row.item.simUsage["ProductDesc"] }}</p>
												</b-col>
												<b-col sm="2">
													<b>SMS Inbox</b>
													<p class="mt-3 text-sm">{{ row.item.simUsage["SMS Inbox"] }}</p>
												</b-col>
												<b-col sm="2">
													<b>Usage</b>
													<p class="mt-3 text-sm">{{ row.item.simUsage["Usage"] }}</p>
												</b-col>
												<b-col sm="2">
													<b>IMEI</b>
													<p class="mt-3 text-sm">{{ row.item.simUsage["IMEI"] }}</p>
												</b-col>
												<b-col sm="2">
													<b>Current Session</b>
													<p class="mt-3 text-sm">
														{{ row.item.simUsage["Current Session"] }}
													</p>
												</b-col>
												<b-col sm="2">
													<b>IP</b>
													<p class="mt-3 text-sm">{{ row.item.simUsage["IP"] }}</p>
												</b-col>
											</b-row>
										</b-card-header>
										<b-card-body class="bg-light-custom">
											<b-row class="">
												<b-col sm="2" class="">
													<b>2G/3G Data</b>
													<p
														class="mt-3 text-sm text-success"
														v-if="row.item.subscriber['2G_3G_Status'] === 'Active'"
													>
														{{ row.item.subscriber["2G_3G_Status"] }}
													</p>
													<p
														class="mt-3 text-sm text-warning"
														v-if="row.item.subscriber['2G_3G_Status'] !== 'Active'"
													>
														{{ row.item.subscriber["2G_3G_Status"] }}
													</p>
												</b-col>
												<b-col sm="2">
													<b>LTE Data</b>
													<p
														class="mt-3 text-sm text-success"
														v-if="row.item.subscriber['LTE_Status'] === 'Active'"
													>
														{{ row.item.subscriber["LTE_Status"] }}
													</p>
													<p
														class="mt-3 text-sm text-warning"
														v-if="row.item.subscriber['LTE_Status'] !== 'Active'"
													>
														{{ row.item.subscriber["LTE_Status"] }}
													</p>
												</b-col>
												<b-col sm="2">
													<b>SMS</b>
													<p class="mt-3 text-sm">{{ row.item.subscriber["SMS"] }}</p>
												</b-col>
												<b-col sm="2">
													<b>Call Waiting</b>
													<p class="mt-3 text-sm">
														{{ row.item.subscriber["Call_Waiting"] }}
													</p>
												</b-col>
												<b-col sm="2">
													<b>CLIP</b>
													<p class="mt-3 text-sm">{{ row.item.subscriber["Clip"] }}</p>
												</b-col>
												<b-col sm="2">
													<b>MMS</b>
													<p class="mt-3 text-sm">{{ row.item.subscriber["MMS"] }}</p>
												</b-col>
											</b-row>
											<b-row>
												<b-col xl="12" class="text-left m-3">
													<span class="h4">Call Forwarding</span>
													<b-tabs content-class="mt-3" class="mt-3">
														<b-tab title="Not Available" active>
															<b-row>
																<b-col md="4">
																	<b>Provisioned</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFNA_Provisioned"] }}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Number</b>
																	<p class="mt-3 text-sm">
																		{{
																			row.item.subscriber["CFNA_Number"]
																				? row.item.subscriber["CFNA_Number"]
																				: "Not Set"
																		}}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Active</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFNA_Active"] }}
																	</p>
																</b-col>
															</b-row>
														</b-tab>
														<b-tab title="Busy">
															<b-row>
																<b-col md="4">
																	<b>Provisioned</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFB_Provisioned"] }}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Number</b>
																	<p class="mt-3 text-sm">
																		{{
																			row.item.subscriber["CFB_Number"]
																				? row.item.subscriber["CFB_Number"]
																				: "Not Set"
																		}}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Active</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFB_Active"] }}
																	</p>
																</b-col>
															</b-row>
														</b-tab>
														<b-tab title="Not Reachable">
															<b-row>
																<b-col md="4">
																	<b>Provisioned</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFNR_Provisioned"] }}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Number</b>
																	<p class="mt-3 text-sm">
																		{{
																			row.item.subscriber["CFNR_Number"]
																				? row.item.subscriber["CFNR_Number"]
																				: "Not Set"
																		}}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Active</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFNR_Active"] }}
																	</p>
																</b-col>
															</b-row>
														</b-tab>
														<b-tab title="Unconditional">
															<b-row>
																<b-col md="4">
																	<b>Provisioned</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFU_Provisioned"] }}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Number</b>
																	<p class="mt-3 text-sm">
																		{{
																			row.item.subscriber["CFU_Number"]
																				? row.item.subscriber["CFU_Number"]
																				: "Not Set"
																		}}
																	</p>
																</b-col>
																<b-col md="4">
																	<b>Active</b>
																	<p class="mt-3 text-sm">
																		{{ row.item.subscriber["CFU_Active"] }}
																	</p>
																</b-col>
															</b-row>
														</b-tab>
													</b-tabs>
												</b-col>
											</b-row>
										</b-card-body>
									</b-card>
								</template>
							</b-table>
						</div>

						<b-row class="mt-4">
							<b-col> Showing {{ (currentPage-1) * perPage + 1 }} to {{ fromPage }} of {{ totalRows }} entries </b-col>
							<b-col xl="auto" md="auto" sm="auto ">
								<b-pagination
									class="flex-fill-custom pr-4"
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									size="sm"
									v-on:input="paginationChanged"
								></b-pagination>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>

				<b-modal
					centered
					size="lg"
					id="view-map"
					title="View Map"
					class="view-map"
					ok-variant="secondary"
					ok-title="Close"
				>
					<ViewMap></ViewMap>
				</b-modal>

				<b-modal
					centered
					size="lg"
					id="send-sms"
					hide-footer
					title="Send SMS"
					class="send-sms"
					cancel-title="Close"
					ok-variant="primary"
					ok-title="Send"
				>
					<SendSMS></SendSMS>
				</b-modal>

				<b-modal
					centered
					size="lg"
					id="hlr-info"
					title="HLR Info"
					class="hlr-info"
					ok-only
					ok-variant="secondary"
					ok-title="Close"
				>
					<HLRInfo></HLRInfo>
				</b-modal>

				<b-modal
					centered
					size="lg"
					id="hss-info"
					title="HSS Info"
					class="hlr-info"
					ok-only
					ok-variant="secondary"
					ok-title="Close"
				>
					<HSSInfo></HSSInfo>
				</b-modal>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import searchDashboardService from "@/common/api-services/search-dashboard-service";
import ViewMap from "../../Components/Provisioning-View-Map";
import SendSMS from "../../Components/Provisioning-Send-SMS";
import HLRInfo from "../../Components/Provisioning-HLR-Info";
import HSSInfo from "../../Components/Provisioning-HSS-Info";

export default {
	name: "SearchResult",
	components: {HLRInfo, SendSMS, ViewMap, HSSInfo},
	data() {
		return {
			items: [],
			fields: [
				{key: "actions", label: ""},
				{key: "blank", label: ""},
				{key: "Status", label: "Status", sortable: true, sortDirection: "desc"},
				{key: "IMSI", label: "IMSI", sortable: true, sortDirection: "desc"},
				{key: "ICCID", label: "ICCID", sortable: true, sortDirection: "desc"},
				{key: "MSISDN", label: "MSISDN", sortable: true, sortDirection: "desc"},
				{key: "simType", label: "SIM Type", sortable: true, sortDirection: "desc"},
				{key: "State", label: "State", sortable: true, sortDirection: "desc"},
			],
			totalRows: 1,
			currentPage: 1,
			perPage: 25,
			pageOptions: [25, 50, 100],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterSettings: {

			},
			filterOn: [],
			loadingStatus: true,
			loadingStatusDetail: false,
			selectedIMSI: 0,
			startPage: 1,
			fromPage: 25,
			lastPage: 1,
		};
	},
	mounted() {
		this.totalRows = this.items.length;

		this.$root.$on("searchStarted", res => {
			this.loadingStatus = true;
		});

		this.$root.$on("getSearchResult", data => {
			let {res, filter} = data;
			this.filterSettings = filter;
			this.loadingStatus = false;
			if (res.result) {
				res.result = res.result.map((obj) => {
				obj['simType'] = obj['SIM Type']
				delete obj['SIM Type'];
				return obj
				})
				this.items = res.result;
				this.totalRows = res.total;
				this.lastPage = Math.ceil(res.total / this.perPage);
			} else {
				this.items = [];
				this.totalRows = 0;
			}

		});
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},

		sortChanged(event) {
			// console.log("sortChanged", event);
			// console.log(this.filterSettings);
			
			this.getSearchResultByFilter(event);
		},

		async getSearchResultByFilter(event) {
			this.$root.$emit("searchStarted");
			
			let filter = {...this.filterSettings};
			if (filter.fSimType === 'All') {filter.fSimType = ''}
			if (filter.fState === 'All') {filter.fState = ''}
			
			let startImsi = filter.fStartIMSI;
			let endImsi = filter.fEndIMSI;
			let iccid = filter.fIccid;
			let msisdn = filter.fMsisdn;
			let simType = filter.fSimType;
			let state = filter.fState;
			let start = this.currentPage * this.perPage - this.perPage;
			let sort = event.sortBy + " " + (event.sortDesc ? "desc" : "asc");
			// let sort = this.filterSettings.fSort;
			let length = this.perPage;

			await searchDashboardService.getSearchResultByFilter(startImsi, endImsi, simType, iccid, msisdn, state, start, length, sort)
			.then(res => {
				// console.log("res", res)
				if (res.result) {
					this.$root.$emit("getSearchResult", {res, filter});
					this.sortBy = event.sortBy;
					this.sortDesc = event.sortDesc;
					// 	this.items = res.result;
				} else {
					this.items = [];
					this.totalRows = 0;
				}
				this.loadingStatus = false;
			})
			.catch(err => {
				// console.log("err", err)
				this.$toast.error(err);
				this.loadingStatus = false;
			})
		},

		rowClick(value) {
			this.loadingStatusDetail = true;
			value.item.openStatus = !value.item.openStatus;
			if (value.item.openStatus) {
				this.items.map((item, index) => {
					if (index === value.index) {
						this.selectedIMSI = item["IMSI"];
						searchDashboardService.getLookupSubscriberByIMSI(this.selectedIMSI).then(res => {
							// //fix the status
							// if (res.success.results[0].Status==='Active' && res.success.results[0].MSISDN ==='' ) {
							//   res.success.results[0].Status==='Disabled';
							// }
							searchDashboardService.getSimUsageByIMSI(this.selectedIMSI).then(res1 => {
								if (res && res.success) {
									this.loadingStatusDetail = false;
									item.subscriber = res.success.results[0];
									item.simUsage = res1;
								}
							});
						});
					}
				});
			}
		},

		paginationChanged(data) {
			// console.log("paginationChanged", data);
			let filter = {...this.filterSettings};
			if (filter.fSimType === 'All') {filter.fSimType = ''}
			if (filter.fState === 'All') {filter.fState = ''}
			
			if (data * this.perPage < this.totalRows) {
				this.fromPage = data * this.perPage;
			} else {
				this.fromPage = this.totalRows;
			}
			this.currentPage = data;
			this.startPage = (this.currentPage - 1) * this.perPage;

			if (!this.items[this.startPage] || !this.items[this.startPage]["imsi"]) {
				// this.$root.$emit("submitSearchFunc", {start: this.startPage, length: this.perPage, filter: filter});
				this.getSearchResultByFilter({sortBy: this.sortBy, sortDesc: this.sortDesc});
			}
		},

		viewMapDetail(imsi) {
			searchDashboardService.getViewMap(imsi).then(res => {
				if (!res["ERROR"]) {
					this.$root.$emit("viewMap", res);
				} else {
					this.$root.$emit("viewMap", res["ERROR"]);
				}
			});
		},

		sendSMSDetail(smisdn) {
			setTimeout(() => {
				this.$root.$emit("sendSMSModal", smisdn);
			}, 2000);
		},

		hlrInfoDetail(imsi) {
			searchDashboardService.getHLRInfo(imsi).then(res => {
				this.$root.$emit("hlrInfo", res);
			});
		},

		hssInfoDetail(imsi) {
			searchDashboardService.getHSSInfo(imsi).then(res => {
				this.$root.$emit("hssInfo", res);
			});
		},

		changeSimTypeBadge(val) {
			if (val === 'Combo') {
				return 'success';
			} else if (val === 'eSIM') {
				return 'warning'
			} else if (val === 'pSIM') {
				return 'danger'
			}
		}
	},
};
</script>
